import React from 'react'
import { TabPanel } from 'primereact/tabview'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { RFIDTagsWidget } from '../../components/rfid-tags-widget'
import { RegisterRfidTagWidget } from '../../components/register-rfid-tag-widget/RegisterRfidTagWidget'
import useText from '../../hooks/useText'
import { LazyTabView } from '../../uikit/LazyTabView'

export const RFIDTagsPage = () => {
    const text = useText()

    return (
        <PageLayoutContainer>
            <LazyTabView>
                <TabPanel header={text('lblRFIDWidget')} leftIcon="pi pi-tags mr-2">
                    <RFIDTagsWidget />
                </TabPanel>
                <TabPanel header={text('lblRejectedRFIDTags')} leftIcon="pi pi-plus mr-2">
                    <RegisterRfidTagWidget />
                </TabPanel>
            </LazyTabView>
        </PageLayoutContainer>
    )
}
